import { Component, Input, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-consumption-trend-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './consumption-trend-chart.component.html',
  styleUrl: './consumption-trend-chart.component.scss'
})
export class ConsumptionTrendChartComponent implements AfterViewInit, OnChanges {
  @Input() isLoadingConsumptionTrend: boolean = false;
  @Input() consumptionTrendData: any = null;
  @ViewChild('chart1', { static: false }) chart1!: ElementRef<HTMLCanvasElement>;
  private chartInstance: any;

  ngAfterViewInit() {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['consumptionTrendData'] && !changes['consumptionTrendData'].firstChange) {
      this.renderChart();
    }
  }

  renderChart() {
    if (!this.consumptionTrendData || !this.chart1) return;
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
    this.chartInstance = new Chart(this.chart1.nativeElement, {
      type: 'line',
      data: {
        labels: this.consumptionTrendData.labels,
        datasets: [{
          label: 'Consumption',
          data: this.consumptionTrendData.data,
          borderColor: '#3b82f6',
          backgroundColor: 'rgba(59,130,246,0.1)',
          fill: true
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false }
        }
      }
    });
  }

  isEmptyTrendData(): boolean {
    const data = this.consumptionTrendData?.data;
    return !data || data.length === 0 || data.every((v: number) => v === 0);
  }
}
